import styled from 'styled-components';

export const ColumnLayout = styled.div`
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  flex-wrap: nowrap;
  overflow: ${(props) => props.overflow || 'visible'};
  width: ${(props) => props.width};
  max-width: ${(props) => props.maxWidth || '100%'};
  height: ${(props) => props.height};
  max-height: ${(props) => props.maxHeight || '100%'};
  background-color: ${(props) => props.backgroundColor};
  padding: ${(props) => props.padding};
  border: ${(props) => props.border};
  border-radius: ${(props) => props.borderRadius};
  justify-content: ${(props) => props.justifyContent};
  align-items: ${(props) => props.alignItems};
  margin: ${(props) => props.margin};
  position: ${(props) => props.position};
  opacity: ${(props) => props.opacity};
  top: ${(props) => props.top};
  left: ${(props) => props.left};
  bottom: ${(props) => props.bottom};
  right: ${(props) => props.right};
`;

export const RowLayout = styled.div`
  display: flex;
  overflow: ${(props) => props.overflow || 'visible'};
  width: ${(props) => props.width || '100%'};
  height: ${(props) => props.height || '100%'};
  background-color: ${(props) => props.backgroundColor};
  padding: ${(props) => props.padding};
  border: ${(props) => props.border};
  border-radius: ${(props) => props.borderRadius};
  justify-content: ${(props) => props.justifyContent};
  align-items: ${(props) => props.alignItems};
  margin: ${(props) => props.margin};
  position: ${(props) => props.position};
  opacity: ${(props) => props.opacity};
  top: ${(props) => props.top};
  left: ${(props) => props.left};
  bottom: ${(props) => props.bottom};
  right: ${(props) => props.right};
  box-shadow: ${(props) => props.boxShadow};
`;
